// Create our initial value...
export const workHardPlayHard = {
  document: {
    nodes: [
      {
        object: 'block',
        type: 'paragraph',
        data: { topkey: 'top' },
        nodes: [
          {
            object: 'inline',
            type: 'string',
            data: { ukey: 'text' },
            nodes: [
              {
                object: 'text',
                leaves: [
                  {
                    text:
                      "You play hard but work harder! Quirky? Maybe, but it's a ",
                  },
                ],
              },
            ],
          },
          {
            object: 'inline',
            type: 'synonym',
            data: { ukey: 'synonym1' },
            nodes: [
              {
                object: 'text',
                leaves: [
                  {
                    text: ' synonym1 ',
                  },
                ],
              },
            ],
          },
          {
            object: 'inline',
            type: 'string',
            data: { ukey: 'text' },
            nodes: [
              {
                object: 'text',
                leaves: [
                  {
                    text: ', ',
                  },
                ],
              },
            ],
          },
          {
            object: 'inline',
            type: 'synonym',
            data: { ukey: 'synonym2' },
            nodes: [
              {
                object: 'text',
                leaves: [
                  {
                    text: ' synonym2 ',
                  },
                ],
              },
            ],
          },
          {
            object: 'inline',
            type: 'string',
            data: { ukey: 'text' },
            nodes: [
              {
                object: 'text',
                leaves: [
                  {
                    text: ' , ',
                  },
                ],
              },
            ],
          },
          {
            object: 'inline',
            type: 'synonym',
            data: { ukey: 'synonym3' },
            nodes: [
              {
                object: 'text',
                leaves: [
                  {
                    text: ' synonym3 ',
                  },
                ],
              },
            ],
          },
          {
            object: 'inline',
            type: 'string',
            data: { ukey: 'text' },
            nodes: [
              {
                object: 'text',
                leaves: [
                  {
                    text:
                      ' life for you. This clever t-shirt design makes a great gift!',
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
}
